import { MsalProvider } from '@azure/msal-react';
import '@mantine/carousel/styles.css';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import '@mantine/notifications/styles.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ErrorBoundary, Provider as RollbarProvider } from '@rollbar/react';
import { AuthContextProvider } from 'auth';
import { PageLoaderFallback } from 'components/PageLoaderFallback';
import { LocaleProvider } from 'contexts';
import NotificationsProvider from 'notifications/NotificationsProvider';
import React, { Suspense, lazy } from 'react';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import ReactDOM from 'react-dom/client';
import 'react-image-crop/dist/ReactCrop.css';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/cjs/Page/AnnotationLayer.css';
import 'react-pdf/dist/cjs/Page/TextLayer.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { resolver, themes } from 'utils';
import { MicrosoftClientApp } from 'utils/clients';
import './i18n';
import './index.css';

const App = lazy(() => import('./App'));

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
});

const rollbarConfig = {
  accessToken: import.meta.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
  environment: import.meta.env.REACT_APP_ROLLBAR_ENV,
  enabled: import.meta.env.REACT_APP_ROLLBAR_ENV === 'prod',
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RollbarProvider config={rollbarConfig}>
      <ErrorBoundary>
        <MantineProvider
          defaultColorScheme={themes.light}
          cssVariablesResolver={resolver}
        >
          <ModalsProvider>
            <Notifications autoClose={4000} />
            <QueryClientProvider client={queryClient}>
              <NotificationsProvider>
                <BrowserRouter>
                  <LocaleProvider>
                    <AuthContextProvider>
                      <GoogleOAuthProvider
                        clientId={import.meta.env.REACT_APP_GOOGLE_CLIENT_ID}
                      >
                        <MsalProvider instance={MicrosoftClientApp}>
                          <Suspense fallback={<PageLoaderFallback />}>
                            <App />
                          </Suspense>
                        </MsalProvider>
                      </GoogleOAuthProvider>
                    </AuthContextProvider>
                  </LocaleProvider>
                </BrowserRouter>
              </NotificationsProvider>
            </QueryClientProvider>
          </ModalsProvider>
        </MantineProvider>
      </ErrorBoundary>
    </RollbarProvider>
  </React.StrictMode>,
);
